import axios from 'axios';
import { SendEmail } from 'src/models';

import { BASE_URL } from './config';
const ENDPOINT = '/api/email/send';

export function sendProfessorsEmail(emails: string[], content: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  const payload: SendEmail = {
    Emails: emails,
    Content: content,
  };

  return apiClient.post(ENDPOINT, payload);
}
